export const LEAD_ROUTING_RULES_PATH = 'api/landlord/lead-routing-rules';
